import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { breakpoints } from '../design-system/tokens/breakpoints';

const base = process.env.PUBLIC_URL || '';

const BRAND_LOGOS = {
  light: {
    src: `${base}/assets/brand/logos/icom-greece-logo-light.png`,
    srcSet: `${base}/assets/brand/logos/icom-greece-logo-light.png 1x, ${base}/assets/brand/logos/icom-greece-logo-light@2x.png 2x`,
  },
  dark: {
    src: `${base}/assets/brand/logos/icom-greece-logo-dark.png`,
    srcSet: `${base}/assets/brand/logos/icom-greece-logo-dark.png 1x, ${base}/assets/brand/logos/icom-greece-logo-dark@2x.png 2x`,
  },
} as const;

const LogoImage = styled.img`
  height: 100%;
  width: auto;
  max-height: 48px;
  max-width: 210px;
  object-fit: contain;
  object-position: left center;
  display: block;

  @media (max-width: ${breakpoints.lg}) {
    max-width: 140px;
    max-height: 36px;
  }

  @media (max-width: ${breakpoints.sm}) {
    max-width: 110px;
  }
`;

const LogoImageSmall = styled(LogoImage)`
  max-height: 40px;

  @media (max-width: ${breakpoints.lg}) {
    max-height: 36px;
  }
`;

const Wrapper = styled.div<{ $size: 'small' | 'medium' | 'large' }>`
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  height: ${props =>
    props.$size === 'large' ? '48px' : props.$size === 'medium' ? '40px' : '32px'};

  @media (max-width: ${breakpoints.lg}) {
    height: 36px;
    flex: 1 1 auto;
  }

  a {
    display: flex;
    align-items: center;
    height: 100%;
    min-width: 0;
    text-decoration: none;
    color: inherit;
  }
`;

interface ICOMHeaderLogoProps {
  size?: 'small' | 'medium' | 'large';
}

/** Top-left header logo. Switches light/dark wordmark with app theme. */
const ICOMHeaderLogo: React.FC<ICOMHeaderLogoProps> = ({ size = 'medium' }) => {
  const { mode } = useTheme();
  const logo = BRAND_LOGOS[mode];
  const Img = size === 'large' ? LogoImage : LogoImageSmall;

  return (
    <Wrapper $size={size}>
      <Img
        src={logo.src}
        srcSet={logo.srcSet}
        width={790}
        height={169}
        alt="ICOM Greece"
      />
    </Wrapper>
  );
};

export default ICOMHeaderLogo;
